import styled from 'styled-components';

export const StyledButton = styled.button`
  position: relative;
  cursor: pointer;
`;
